<template>
<section class="big-video">
	<div class="container">
		<div class="video-wrapper">
			<iframe src="https://www.youtube.com/embed/ywYgEuQ9pNE?si=4aRJsE31ub0ZgxHY&amp;start=258" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionVideo',
}
</script>
